<template>
  <div ref="plot">
  </div>
</template>

<script>
import * as d3 from "d3";
import _ from "lodash";
import { drawVerticalLines } from '../util';
export default {
    props: ['input', 'meta','lineCoordinates'],
    watch: {
        input() {
            this.render();
        },
        // Opted for re-rendering the entire component for readability and simplicity. 
        // This approach needs to be reviewed and approved by Ivan for potential performance considerations.
        lineCoordinates: {
            handler() {
                this.render();
            },
            deep: true
        },
    },
    methods: {
        render() {
            const el = this.$refs['plot'];
            el.innerHTML = ''; // clear

            if (this.input) {
                const bins = this.input.bins;
                const cov_gt0 = this.input.cov_gt0;
                const cov_gt1 = this.input.cov_gt1;
                const cov_gt2 = this.input.cov_gt2;


                const margin = {top: 40, right: 30, bottom: 30, left: 60}, // changed the top margin to fit the variant in coverage plot
                      width = 1000 - margin.left - margin.right,
                      height = 200 - margin.top - margin.bottom;

                const svg = d3.select(el)
                    .append("svg")
                    .attr("width", width + margin.left + margin.right)
                    .attr("height", height + margin.top + margin.bottom)
                    .append("g")
                    .attr("transform", `translate(${margin.left}, ${margin.top})`);

                const x = d3.scaleLinear()
                    .domain([0, this.meta.x_limit])
                    .range([ 0, width ]);

                svg.append("g")
                    .attr("transform", `translate(0, ${height})`)
                    .call(d3.axisBottom(x));

                const y = d3.scaleLinear()
                    .domain([0, this.meta.y_limit])
                    .range([ height, 0 ]);

                svg.append("g")
                    .call(d3.axisLeft(y).ticks(5));

                // const lines = ['cov_gt0', 'cov_gt1', 'cov_gt2'].map(lineName => this.input.bins.map((bin, i) => ({x: bin, y: this.input[lineName][i]})));

                const line = d3.line()
                    .x(d => x(d.x))
                    .y(d => y(d.y));


                const lineNames = ['cov_gt0', 'cov_gt1', 'cov_gt2'];
                const validLines = lineNames
                    .filter(name => this.input[name] !== null)
                    .map(name => this.input.bins.map((bin, i) => ({ x: bin, y: this.input[name][i] })));

                const colors = ['red', 'lightblue', 'darkblue'].slice(0, validLines.length);

                validLines.forEach((lineData, i) => {
                    svg.append("path")
                        .datum(lineData)
                        .attr("fill", "none")
                        .attr("stroke", colors[i])
                        .attr("stroke-width", 1.5)
                        .attr("d", line);
                });

                // Add a legend
                const legend = svg.selectAll('.legend')
                    .data(validLines)
                    .enter().append('g')
                    .attr('class', 'legend')
                    .attr('transform', (d, i) => `translate(0,${i * 20})`);

                // Draw legend colored rectangles
                legend.append('rect')
                    .attr('x', width - 38)
                    .attr('width', 18)
                    .attr('height', 18)
                    .style('fill', (d, i) => colors[i]);

                // Draw legend text
                legend.append('text')
                    .attr('x', width - 15)
                    .attr('y', 9)
                    .attr('dy', '.35em')
                    .style('font-size', '12px')
                    // .style('text-anchor', 'end')
                    .text((d,i) => i);

                // Add title to coverage plot
                svg.append('text')
                    .attr('x', 310) // Approximate position to the top start of the plot
                    .attr('y', -10) 
                    .style('text-anchor', 'end')
                    .style('font-size', '14px')
                    .style('font-weight', 'bold')
                    .style('fill', '#333333')
                    .text("RNA-seq read coverage (stratified by genotype)");

                // Add variant to coverage plot
                svg.append('text')
                    .attr('x', width - 10)
                    .attr('y', -10) 
                    .style('text-anchor', 'end')
                    .style('font-size', '14px')
                    .text(this.meta.variant);
                
                // Add facet label
                svg.append("rect")
                    .attr("x", width)
                    .attr("y", 0)
                    .attr("width", 75)
                    .attr("height", height)
                    .style("fill", "#f0f0f0");

                
               
                svg.append('text')
                    .attr("x", 0)
                    .attr("y", 0)
                    .attr('text-anchor', 'middle')
                    .attr('transform', `translate(${width+20},${height/2}) rotate(-90)`)
                    .style('font-size', '16px')
                    .text(this.meta.gene_name);


                // Left label
                svg.append('text')
                    .attr('transform', `translate(-30, ${height / 2}) rotate(-90)`)
                    .style('text-anchor', 'middle')
                    .style('font-size', '16px')
                    .text('FPM');

                // Checks if the quantification method is 'leafcutter' and there are line coordinates available. 
                // If True, it calls `drawVerticalLines` to render vertical lines on the SVG element.
                if (this.lineCoordinates.length && this.meta.quant_method === "leafcutter") {
                    drawVerticalLines(svg, x, height, this.lineCoordinates)
                }

            }
        }
    }
}
</script>

<style scoped>

</style>